angular
  .module('app')
  .config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider, AUTH_EVENTS) {
  $locationProvider.html5Mode(true).hashPrefix('!');
  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('main', {
      url: '/',
      abstract: true,
      controller: 'MainindexController',
      controllerAs: 'vm',
      templateUrl: 'app/main/index.html'
    })
    .state('main.index', {
      url: '',
      templateUrl: 'app/index/index.html',
      controller: 'IndexController',
      controllerAs: 'vm'
    })
    .state('main.resetpassword', {
      url: 'resetpassword',
      templateUrl: 'app/reset/reset.html',
      controller: 'ResetController',
      controllerAs: 'vm'
    })
    .state('dashboard', {
      url: '/dashboard',
      templateUrl: 'app/dashboard/index.html',
      abstract: true,
      controller: 'DashController',
      controllerAs: 'vm',
      data: {
        authorize: [AUTH_EVENTS.loginSuccess]
      }
    })
    .state('dashboard.main', {
      url: '',
      templateUrl: 'app/dashboard/dashboard.html',
      controller: 'DashMainController',
      controllerAs: 'vm',
      data: {
        authorize: [AUTH_EVENTS.loginSuccess]
      }
    })
    .state('dashboard.newFilm', {
      url: '/new-film',
      params: {
        id: null,
        categoria: null
      },
      templateUrl: 'app/newfilm/newfilm.html',
      controller: 'NewFilmController',
      controllerAs: 'vm',
      data: {
        authorize: [AUTH_EVENTS.loginSuccess]
      }
    })
    .state('dashboard.editFilm', {
      url: '/edit-film',
      params: {
        id: null,
        categoria: null
      },
      templateUrl: 'app/editfilm/editfilm.html',
      controller: 'EditFilmController',
      controllerAs: 'vm',
      data: {
        authorize: [AUTH_EVENTS.loginSuccess]
      }
    })
    .state('dashboard.editPhoto', {
      url: '/edit-photo',
      params: {
        id: null,
        categoria: null
      },
      templateUrl: 'app/editphoto/editphoto.html',
      controller: 'EditPhotoController',
      controllerAs: 'vm',
      data: {
        authorize: [AUTH_EVENTS.loginSuccess]
      }
    })
    .state('dashboard.editVideo', {
      url: '/edit-video',
      params: {
        id: null,
        categoria: null
      },
      templateUrl: 'app/editvideo/editvideo.html',
      controller: 'EditVideoController',
      controllerAs: 'vm',
      data: {
        authorize: [AUTH_EVENTS.loginSuccess]
      }
    })
    .state('dashboard.profile', {
      url: '/profile',
      templateUrl: 'app/profile/profile.html',
      controller: 'ProfileController',
      controllerAs: 'vm',
      data: {
        authorize: [AUTH_EVENTS.loginSuccess]
      }
    })
    .state('dashboard.pay', {
      url: '/payment',
      params: {
        id: null,
        categoria: null
      },
      templateUrl: 'app/pay/pay.html',
      controller: 'PayController',
      controllerAs: 'vm',
      data: {
        authorize: [AUTH_EVENTS.loginSuccess]
      }
    })
    .state('dashboard.uploadmedia', {
      url: '/upload',
      params: {
        id: null,
        categoria: null
      },
      templateUrl: 'app/media/media.html',
      controller: 'MediaController',
      controllerAs: 'vm',
      data: {
        authorize: [AUTH_EVENTS.loginSuccess]
      }
    });
}
